import { render, staticRenderFns } from "./sport_competition_congratulate_winner.vue?vue&type=template&id=7c9213b9&scoped=true&"
import script from "./sport_competition_congratulate_winner.vue?vue&type=script&lang=js&"
export * from "./sport_competition_congratulate_winner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9213b9",
  null
  
)

export default component.exports